import React from "react";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Form from "../layout/form.jsx";
import Loader from "../layout/loader.jsx";
import { toast } from "react-toastify";
import API from "../../services/api.jsx";
import Helpers from "../../services/helpers.jsx";

class UserRoleEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      breadcrumb: {
        title: "back to Roles",
        path: "/users/roles",
      },
      fields: {
        name: { label: "Name", type: "text", required: true },
        overallPermission: {
          label: "Overall permission",
          type: "select",
          required: true,
          options: Helpers.mapToOptions(Helpers.OVERALL_PERMISSION),
        },
        playlistAddDeletePermission: {
          label: "Playlist add/delete permission",
          type: "select",
          required: true,
          options: Helpers.mapToOptions(Helpers.PLAYLIST_ADD_DELETE_PERMISSION),
        },
        permissions: {
          type: "checkbox-list",
          fullWidth: true,
          list: [
            {
              options: Helpers.mapToOptions(Helpers.CLIENTS_PERMISSIONS),
            },
            {
              options: Helpers.mapToOptions(Helpers.DEVICES_PERMISSIONS),
            },
            {
              options: Helpers.mapToOptions(Helpers.CAMPAIGNS_PERMISSIONS),
            },
            {
              options: Helpers.mapToOptions(Helpers.PLAYLISTS_PERMISSIONS),
            },
            {
              options: Helpers.mapToOptions(Helpers.COLLECTIONS_PERMISSIONS),
            },
            {
              options: Helpers.mapToOptions(Helpers.USERS_PERMISSIONS),
            },
            {
              options: Helpers.mapToOptions(Helpers.AFFILIATES_PERMISSIONS),
            },
            {
              options: Helpers.mapToOptions(Helpers.ROLES_PERMISSIONS),
            },
            {
              options: Helpers.mapToOptions(Helpers.APK_PERMISSIONS),
            },
          ],
        },
      },
      entity: null,
    };
    this.saveEntity = this.saveEntity.bind(this);
  }

  componentDidMount() {
    API.getRole(this.props.match.params.roleId).then((client) =>
      this.setState({ loading: false, entity: client })
    );
  }

  saveEntity(fields) {
    this.setState({ loading: true });

    API.update("roles", this.props.match.params.roleId, fields)
      .then(() => {
        toast.success("Role has been updated");
        this.props.history.push("/users/roles");
      })
      .catch(() => {
        // toast.error("An unexpected error has occured, please try again");
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head title={"Edit role"} breadcrumb={this.state.breadcrumb} />
          <Content>
            <Form
              fields={this.state.fields}
              cancel={() => this.props.history.push("/users/roles")}
              save={this.saveEntity}
              entity={this.state.entity}
              hideCancel={!Helpers.checkPermissions('roles:edit')}
              hideSave={!Helpers.checkPermissions('roles:edit')}
              disabled={!Helpers.checkPermissions('roles:edit')}
            />
          </Content>
        </>
      );
  }
}

export default UserRoleEdit;
